"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Client = _interopRequireDefault(require("./Client"));

var _utils = require("./_utils");

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2018 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

/**
 * The Collaboration class handles listing collaboration data (i.e. collaborators and invitations) for a specific resource.
 */
var Collaboration = /*#__PURE__*/function () {
  function Collaboration() {
    (0, _classCallCheck2["default"])(this, Collaboration);
  }

  (0, _createClass2["default"])(Collaboration, [{
    key: "get",

    /**
     * Get collaborations for the user.
     * @param {String} resourceUrl - CC Storage path (path based or ID-based)
     * @returns {Promise}
     */
    value: function get(resourceUrl) {
      if (resourceUrl && resourceUrl.trim() !== '') {
        return _Client["default"].instance.fetch({
          type: 'collaboration.get',
          urlPath: '/collaboration/' + (0, _utils.encodeURIComponentEachSubdomain)((0, _utils.getUrlPath)(resourceUrl)) + '?fields=descendants'
        });
      }

      return Promise.reject({
        error: "Missing request paramaters",
        status: 500
      });
    }
    /**
      * Return whether the user has invitation rights for the given resource
      *
      * NOTE: For Phase 1, this should return true if the userId is the owner of the resourceUrl
      *
      * @param {String} resourceUrl - CC Storage path (path based or ID-based)
      * @param {String} userId - AdobeID of user logged in
      * @return {Promise} A promise that resolves to a boolean whether the user has the invitation rights or not.
      */

  }, {
    key: "canUserInvite",
    value: function canUserInvite(resourceUrl, userId) {
      if (resourceUrl && userId && resourceUrl.trim() !== '' && userId.trim() !== '') {
        var checkIfUserIsOwner = function checkIfUserIsOwner(response) {
          return userId === (response && response.ownerId);
        };

        return this.get(resourceUrl).then(checkIfUserIsOwner);
      }

      return Promise.reject({
        error: "Missing request paramaters",
        status: 500
      });
    }
  }]);
  return Collaboration;
}();
/**
 * Exports the Collaboration class.
 */


var _default = Collaboration;
exports["default"] = _default;